import { Component } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';


@Component({
  selector: 'app-in-contruction-page',
  imports: [TranslateModule],
  templateUrl: './in-contruction-page.component.html',
  styleUrl: './in-contruction-page.component.scss'
})
export class InContructionPageComponent {
  // Note: Make sure the logo file exists at assets/images/logo-excuela.png
  // If the logo is in a different location, update the src path in the HTML template
}
